import { IThunderboltEntry } from '@wix/editor-elements-types';

const entry: IThunderboltEntry = {
  loadComponent: hostAPI => {
    hostAPI.registerComponent('SeoTpaGallery', () => {
      return import(
        './viewer/SeoTpaGallery' /* webpackChunkName: "SeoTpaGallery" */
      ).then(componentModule => {
        return {
          component: componentModule.default,
        };
      });
    });
  },
};

export default entry;
